import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TNomenclatureDM from './TNomenclatureDM'

/**
 * Spotřební daň
 */
export default class TExciseTaxSummaryDM extends Data {
	public static className = 'TExciseTaxSummaryDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * Identifikace hlavičky
	 */
	HeaderRID?: number

	/**
	 * Typ hlavičky
	 */
	HeaderType?: number

	/**
	 * Částka
	 */
	Price?: number

	/**
	 * Množství
	 */
	Amount?: number

	/**
	 * Spotřební daň
	 */
	ExciseTaxId?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * ExciseTaxDateCalc
	 */
	ExciseTaxDateCalc?: Date

	/**
	 * Nomenklatura
	 */
	@Type(() => TNomenclatureDM)
	NomenklatureId?: TNomenclatureDM
}